import { useMemo } from 'react';

import { useInternalToolsMenu } from '../../internalTools/useInternalToolsMenu';

const useFeatureOverrideFlag = () => {
  const { getToolValue, isToolsLoading } = useInternalToolsMenu();
  const isEnabled = useMemo(() => {
    if (import.meta.env.VITE_API_ENV !== 'production' && getToolValue('feature-flag-override')) {
      return true;
    }
    return false;
  }, [getToolValue]);

  return { isEnabled: isEnabled, isLoading: isToolsLoading };
};

export { useFeatureOverrideFlag };
